<template>
    <v-container fluid grid-list-lg
          :data-watch-loader="watchLoader">
        <v-layout v-if="!isLoaded" justify-center align-center fill-height>
            <loader></loader>
        </v-layout>
        <data-table
            v-if="filter.status === 0"
            @action="onRowAction"
            :actions="actions"
            :items="items"
            :headers="headers"
            apiEndpoint="visitActions"
            :staticData="true"
            @staticItems="staticItems"
            :filter="filter"
            mode="select"/>
        <toast-message></toast-message>
        <confirmation-dialog></confirmation-dialog>
    </v-container>
</template>

<script>
import moment from 'moment';
import DataTable from './DataTable';

export default {
  components: {
    DataTable
  },
  data() {
    return {
      search: null,
      isLoaded: false,

      actions: [
        { name: 'Detalii vizită', color: '', event: 'open' }
      ],

      headers: [
        {
          text: 'Data',
          align: 'left',
          value: 'created_at',
          format: (item) => {
            return `${moment(item.created_at).format('DD/MM/YYYY HH:mm')}<br>
                    <strong>${item.path}</strong><br>
                    <strong>Client:</strong> ${item.visit.machine.client_location.client.name}<br>
                    <strong>Locație client:</strong> ${item.visit.machine.client_location.name}`;
          }
        }
      ],
      filter: {},
      items: []
    };
  },

  computed: {

    watchLoader: {
      get() {
        if (this.isLoaded) {
          this.$store.commit('CENTER_VIEW_VERTICAL', false);
        } else {
          this.$store.commit('CENTER_VIEW_VERTICAL', true);
        }
      }
    }

  },

  created() {
    this.isLoaded = false;
    this.loadDependencies().then(() => {
      this.isLoaded = true;
      this.loadFilter();
    });
  },

  methods: {
    staticItems(values) {
      this.items = values ? values.map(item => {
        if (item.action && item.action.id) {
          item.path = this.$store.getters['actions/action'](item.action.id).path;
        } else {
          item.path = '- nedefinit -';
        }
        return item;
      }) : [];
    },

    loadFilter() {
      this.filter = {
        status: 0
      };
    },

    loadDependencies() {
      return Promise.all([
        this.$store.dispatch('actions/LOAD', {filter: { rowsPerPage: -1 }})
      ]);
    },

    onRowAction(event) {
      switch (event.name) {
        case 'open':
          this.$router.push({ name: 'Visit', params: { id: event.data.visit_id } });
          break;
      }
    }
  }
};
</script>
